export default "__VITE_ASSET__CDjmp8jv__"